import React from "react";
import "./extraPack.css";
import includedIcon from "../../../../../styles/img/NewPackSelector/included-icon.svg";
import notIncludedIcon from "../../../../../styles/img/NewPackSelector/not-included-icon.svg";
import Card from "../Details/Card";

const ExtraPack = ({ pack, selectPack, isBottom, hasThreePack }) => {

  return (
    <div className={`extraPack-container ${ isBottom? 'isBottom' : ''} ${ hasThreePack? 'threePacks' : ''}`}>
      <Card packDetails={pack} goToNextStep={selectPack} isBottom={isBottom}/>
      <div className="extraPack-item-container">
        <h4 className="extraPack-item-title">{pack.sectionTitles[0]}</h4>
        <ul className="extraPack-item-list">
          {pack.options &&
            pack.options.length &&
            pack.options.map((option, index) => {
              return (
                <li className="extraPack-item-listItem" key={`option_${index + 1}`}>
                  <img className="includedIcon" src={includedIcon} alt="ok" />
                  {isBottom ? option : <span dangerouslySetInnerHTML={{__html: option}}></span>}
                </li>
              );
            })}
        </ul>
      </div>
      <div className="extraPack-item-container todo">
        <h4 className="extraPack-item-title">{pack.sectionTitles[1]}</h4>
        <ul className="extraPack-item-list">
          {pack.todoOptions &&
            pack.todoOptions.length &&
            pack.todoOptions.map((todo, index) => {
              return (
                <li className="extraPack-item-listItem" key={`todo_${index + 1}`}>
                {
                    isBottom ? <img className="includedIcon" src={notIncludedIcon} alt="ok" /> 
                    : <span className='extrapack-item-listItem-number'>{index + 1}</span>
                }
                  {todo}
                </li>
              );
            })}
        </ul>
      </div>
    </div>
  );
};
export default ExtraPack;



// WEBPACK FOOTER //
// ./src/components/buy/table-checkouts/PackSelectorPage/ExtraPack/ExtraPack.js